import { useSelector } from 'react-redux';

import { getMaintenanceMode } from '../../../redux/appConfig/selectors';

export const useMaintenanceModeData = (): AppConfig.MaintenanceMode | null => {
  const maintenanceModeList = useSelector(getMaintenanceMode);

  const maintenanceMode = maintenanceModeList[0] ?? null;

  return maintenanceMode;
};
